import type { IReportType } from 'app/services/reportsBoardApi';

/**
 * Generic per-report tab shell shown while a generate round-trip is running —
 * the markup every legacy tab template shares (e.g.
 * tabs/unit_technical_data/tmpl/unit_technical_data.tmpl:1-16 /
 * tabs/weight_calc/tmpl/weight_calc.tmpl:1-16): container-header with the
 * group + report names, then the `.generation-in-progress` preloader inside
 * the report content. The legacy hardcodes the group caption per template
 * ('Engineering', 'Sales', 'Management'); here it comes from the report row's
 * group, which is what those hardcodes mirror.
 *
 * `faded` reproduces the 4.5s `opacity-0` fade (action.js:124-128); at 5s the
 * page unmounts this pane and re-activates the empty board (action.js:176-180).
 * The 5c–5e sub-phases replace this shell with the real per-report tabs.
 */
interface GeneratingReportTabProps {
  report: IReportType;
  faded: boolean;
}

const GeneratingReportTab = ({ report, faded }: GeneratingReportTabProps) => (
  // col-xs-12 mirrors the static pane divs in main.tmpl; 'active' is what
  // openReport adds at generate time (action.js:84) and supplies the pane's
  // full height.
  <div id={report.value} className="col-xs-12 active" style={{ display: 'block' }}>
    <div className="container-header clearfix">
      <h3 className="left">
        <span className="group-name" tooltip={` : ${report.name}`}>
          {report.group}
        </span>
        <span className="report-name">{report.name}</span>
      </h3>
    </div>
    <div className="report-content col-xs-12">
      <div className="content">
        <div className="content-item full-height" style={{ overflow: 'auto' }}>
          <div className={`preloader-container generation-in-progress${faded ? ' opacity-0' : ''}`}>
            <div className="preloader active">Report generation in progress...</div>
          </div>
          <div id={`${report.value}_structure`} className="full-height" />
        </div>
      </div>
    </div>
  </div>
);

export default GeneratingReportTab;
